import React, { useEffect, useState } from 'react';
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import moment from 'moment';

const ServicesFormHeader = ({ elevatorDetails }) => {

  return (
    <>
      <RadioGroup defaultValue="service" name="type">
        <Box display="flex" mt="1rem" justifyContent="center">
          <FormControlLabel
            value="service"
            control={<Radio />}
            label="Servisim"
          />
          <FormControlLabel
            value="control"
            control={<Radio />}
            label="Kontroll"
          />
        </Box>
      </RadioGroup>
      <Box
        display="grid"
        gridTemplateColumns="1fr 1fr 1fr"
        gap="10px"
        m="1rem 2rem 0">
        <TextField
          size="small"
          required
          label="Projekti"
          name="project"
          defaultValue={elevatorDetails?.buildingName || ''}
        />  
        <TextField
          size="small"
          required
          label="Emri i Ashensorit"
          name="elevator"
          defaultValue={elevatorDetails?.name || ''}
        />
        <TextField
          size="small"
          required
          label="Adresa"
          name="address"
          defaultValue={elevatorDetails?.buildingAddress || ''}
        />
        <TextField
          size="small"
          required
          label="Numri serik"
          name="elevatorId"
          defaultValue={elevatorDetails?.elevatorId || ''}

        />
      <TextField
          size="small"
          label="Klienti"
          name="client"
          defaultValue={elevatorDetails?.client || ''}
        />
        <TextField
          size="small"
          required
          label="Periudha"
          name="period"
          defaultValue={elevatorDetails?.period || moment().format('MM/YYYY')}
        />
        <TextField
          type="date"
          name="date"
          defaultValue={elevatorDetails?.date || moment().format('yyyy-MM-DD')}
          required
          label="Data"
          fullWidth
        />
      </Box>
    </>
  );
};

export default ServicesFormHeader;
